<template>
  <div class="sim-task-items">
    <div v-if="!items.length" class="sim-task-items__empty">{{ translate('sim_task.compact.empty') }}</div>
    <table v-else>
      <thead><tr>
        <th>ICCID</th>
        <th>{{ translate('sim_task.compact.operator_account') }}</th>
        <th>{{ translate('sim_task.compact.execution') }}</th>
        <th>{{ translate('sim_task.compact.result') }}</th>
        <th>{{ translate('sim_task.compact.checks') }}</th>
        <th>{{ translate('sim_task.compact.next_check') }}</th>
      </tr></thead>
      <tbody>
        <tr v-for="item in items" :key="item.id">
          <td class="sim-task-items__iccid">
            <span>{{ item.iccid }}</span>
            <button type="button" class="sim-task-items__copy"
                    :title="translate('sim_task.compact.copy_iccid')"
                    :aria-label="translate('sim_task.compact.copy_iccid') + ': ' + item.iccid"
                    @click="copyIccid(item.iccid)"><i class="fa fa-copy" aria-hidden="true"></i></button>
          </td>
          <td class="sim-task-items__account">{{ item.mno_name || item.mno || '—' }} / {{ item.oper_account || '—' }}</td>
          <td><span class="sim-task-items__status" :class="statusClass(item.status)">{{ item.status_label || item.status || '—' }}</span></td>
          <td>{{ item.current_status_label || item.current_status || translate('sim_task.compact.not_checked') }}</td>
          <td class="sim-task-items__checks">{{ checksText(item) }}</td>
          <td>{{ nextCheckText(item) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'SimTaskItems',
  props: { items: { type: Array, default: () => [] } },
  data () { return { now: Date.now(), clockTimer: null } },
  mounted () { this.startClock() },
  activated () { this.startClock() },
  deactivated () { this.stopClock() },
  beforeDestroy () { this.stopClock() },
  methods: {
    startClock () {
      this.stopClock()
      this.now = Date.now()
      this.clockTimer = setInterval(() => { this.now = Date.now() }, 10000)
    },
    stopClock () { clearInterval(this.clockTimer); this.clockTimer = null },
    checksText (item) {
      return item.checks_count != null && item.checks_limit != null ? `${item.checks_count} / ${item.checks_limit}` : '—'
    },
    nextCheckText (item) {
      if (['completed', 'failed', 'cancelled', 'timed_out'].includes(item.status)) return '—'
      if (item.next_retry_at == null) {
        return ['new', 'ready', 'queued'].includes(item.status) ? this.translate('sim_task.compact.on_start') : '—'
      }
      const timestamp = Number(item.next_retry_at) * 1000
      const date = new Date(timestamp)
      if (!Number.isFinite(timestamp) || Number.isNaN(date.getTime())) return '—'
      if (timestamp <= this.now) return this.translate('sim_task.compact.awaiting_start')
      return date.toLocaleString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })
    },
    statusClass (status) {
      if (status === 'completed') return 'is-success'
      if (['failed', 'timed_out'].includes(status)) return 'is-error'
      if (['waiting', 'retry'].includes(status)) return 'is-waiting'
      if (status === 'in_progress') return 'is-running'
      return 'is-neutral'
    },
    copyIccid (iccid) {
      this.copy_to_clipboard(String(iccid))
      this.global_notify('info', this.translate('clipboard.value_save_buffer'))
    }
  }
}
</script>

<style scoped>
.sim-task-items { width: 100%; overflow-x: auto; }
.sim-task-items table { width: 100%; min-width: 1000px; border-collapse: collapse; font-size: 14px; }
.sim-task-items th, .sim-task-items td { padding: 14px 12px; text-align: left; vertical-align: middle; border-bottom: 1px solid #eceeef; }
.sim-task-items th { font-weight: 600; color: #42494f; white-space: nowrap; background: #f8f9fa; }
.sim-task-items__iccid, .sim-task-items__checks { white-space: nowrap; font-variant-numeric: tabular-nums; }
.sim-task-items__account { overflow-wrap: anywhere; min-width: 180px; }
.sim-task-items__copy { border: 0; background: transparent; padding: 5px; color: #68757d; cursor: pointer; }
.sim-task-items__copy:hover, .sim-task-items__copy:focus { color: #237ca0; }
.sim-task-items__status { display: inline-block; border-radius: 4px; padding: 4px 8px; font-size: 12px; }
.is-success { color: #25643c; background: #e8f5ed; }
.is-error { color: #9d3434; background: #fcecec; }
.is-waiting { color: #805e18; background: #fff4dc; }
.is-running { color: #265e89; background: #eaf3fc; }
.is-neutral { color: #59636b; background: #edf0f2; }
.sim-task-items__empty { padding: 28px; text-align: center; color: #68757d; background: #f8f9fa; }
</style>
